import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

export const HOW_IT_WORKS = [
  {
    n: "01",
    title: "Tell Us About Your Property",
    copy: "Share your name, contact, email, property location, property type, current status, tenant status and the services you need.",
  },
  {
    n: "02",
    title: "Free Initial Assessment",
    copy: "We understand the property and your requirements — no charge, no obligation.",
  },
  {
    n: "03",
    title: "Property Inspection",
    copy: "Where required, we physically inspect the property and understand its current condition.",
  },
  {
    n: "04",
    title: "Customized Proposal",
    copy: "You receive a clear scope, service charges, expected costs, timeline and responsibilities.",
  },
  {
    n: "05",
    title: "Owner Approval",
    copy: "No major work begins without your approval. You stay in control of every significant decision.",
  },
  {
    n: "06",
    title: "We Take Care of It",
    copy: "You receive updates and records while we manage the work locally in Hyderabad.",
  },
];

export const HowItWorksSection = () => (
  <section className="bg-ivory py-24 sm:py-32" data-testid="how-it-works-section">
    <div className="container-site">
      <SectionHeading
        chapter="08"
        eyebrow="How It Works"
        title="Six Steps. Zero Guesswork."
        copy="A structured onboarding designed for owners who cannot be physically present."
      />

      <Stagger className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3" gap={0.08}>
        {HOW_IT_WORKS.map((s) => (
          <StaggerItem key={s.n}>
            <div className="card-lift h-full rounded-2xl border border-navy-900/10 bg-white p-7" data-testid={`how-step-${s.n}`}>
              <span className="font-display text-4xl font-extrabold tracking-tight text-gold-500/80">{s.n}</span>
              <h3 className="mt-4 font-display text-lg font-extrabold tracking-tight text-navy-900">{s.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-muted-foreground">{s.copy}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>

      <Reveal delay={0.15}>
        <div className="mt-12">
          <Link to="/how-it-works" className="btn-navy" data-testid="how-it-works-cta">
            See the Full Process <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
